import email from '../assets/email.png';
import mobile from '../assets/mobile.png';

import sass from '../assets/sass.png';
import javascript from '../assets/javascript.png';
import vue from '../assets/vue.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  email,
  mobile,
  javascript,
  sass,
  vue,
  profile,
  circle,
  logo,
};
